/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { useEffect, useRef } from 'react'
import ApexCharts from 'apexcharts'

interface iChartProps{
  id: string
  labels: string[]
  colors: string[]
  series: number[]
  onChoiceAderencia: (item: number) => void
}

export const PieChart: React.FC<iChartProps> = ({ id, labels, colors, series, onChoiceAderencia }) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const options = {
      series,
      labels,
      colors,
      chart: {
        type: 'pie',
        height: 240,
        width: 240,
        events: {
          dataPointSelection: function(chartContext: any, seriesIndex: any, opts: any) {
            onChoiceAderencia(opts.dataPointIndex)
          }
        }
      },
      legend: {
        enabled: false,
        show: false
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val: any) {
            return val
          }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (_val: number, opts: any) {
          return opts.w.config.series[opts.seriesIndex]
        },
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          colors: ['#fff']
        }
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: false // DESATIVA o texto no meio
            }
          }
        }
      }
    }

    // cada execucao desenha num elemento proprio, assim o render assincrono de um grafico nao atropela o do proximo
    const el = document.createElement('div')
    ref.current?.appendChild(el)
    const chart = new ApexCharts(el, options)
    const renderizado = chart.render()
    return () => {
      el.remove()
      renderizado.then(() => chart.destroy()).catch(() => {})
    }
  }, [series.join(','), labels.join(',')])

  return (
        <div id={id} ref={ref}></div>
  )
}
